import { defineMessages } from "react-intl";

const messages = defineMessages({
  visibilityPrivate: {
    id: "Package.CenterPackageForm.visibilityPrivate",
    defaultMessage: "Private",
  },
  visibilityPublic: {
    id: "Package.CenterPackageForm.visibilityPublic",
    defaultMessage: "Public",
  },
  textPrice: {
    id: "Package.CenterPackageForm.textPrice",
    defaultMessage: "Price of offerings: {price}",
  },
  textDuration: {
    id: "Package.CenterPackageForm.textDuration",
    defaultMessage: "Default duration: {duration}",
  },
  helperPrice: {
    id: "Package.CenterPackageForm.helperPrice",
    defaultMessage: "This price is applied if none is set",
  },
  duration: {
    id: "Package.CenterPackageForm.duration",
    defaultMessage: "Duration",
  },
  helperDuration: {
    id: "Package.CenterPackageForm.helperDuration",
    defaultMessage: "This duration is applied if none is set",
  },
  minutes: {
    id: "Package.CenterPackageForm.minutes",
    defaultMessage: "min",
  },
});

export default messages;
